import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DataService } from '../../services/context/data.service';
import { RefDataService } from '../../services/context/ref-data.service';

import { Utils } from '../../../utils/utils';
import * as fromModel from '../../services/models';
import { Constant } from '../../../environments/constants';

import { MatDialog } from '@angular/material/dialog';
import { DeleteConfirmationComponent } from '../../context-components/delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'gp-edit-income',
  templateUrl: './edit-income.component.html',
  styleUrls: ['./edit-income.component.scss']
})
export class EditIncomeComponent implements OnInit, OnDestroy {

  form: FormGroup;
  mode = "edit";
  validationMsg='';

  income: fromModel.Income;
  incomeOwner: fromModel.PlanClient;
  incomeOwners: fromModel.PlanClient[];
  infRate;
  
  startTypes: fromModel.CodeValue[];
  endTypes: fromModel.CodeValue[];
  incomeTypes: fromModel.CodeValue[];

  constructor(
    private dataService: DataService,
    private refDataService: RefDataService,
    private readonly fb: FormBuilder,
    private currencyPipe: CurrencyPipe,
    private dialogRef: MatDialogRef<EditIncomeComponent>,
    private dialog: MatDialog, 
    @Inject(MAT_DIALOG_DATA) private inputData: any) { 
    this.form = this.fb.group({
      incDesc: ['', [Validators.required, Validators.maxLength(30)]],
      incType: ['', [Validators.required]],
      owner: ['', [Validators.required]],
      growthType: ['', [Validators.required]],
      growthRate: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
      isTaxable: ['', [Validators.required]],
      isAdjToFutureDollar: ['', [Validators.required]],
      startType: ['', [Validators.required]],
      startYr: ['', [Validators.required]],
      startAge: ['', [Validators.required]],
      endType: ['', [Validators.required]],
      endYr: ['', [Validators.required]],
      duration: ['', [Validators.required]],
      endAge: ['', [Validators.required]],
      amount: ['', [Validators.required,  Validators.min(1)]],
      isMonthly: ['', [Validators.required]]
      }    
    );
  }

  ngOnInit() {       
    this.startTypes = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.StartType);
    this.endTypes = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.EndType);    
    this.incomeTypes = this.refDataService.getPlanningUIRefDataByType(fromModel.PLANNINGUIREFTYPE.Incomes);  
    this.infRate = this.refDataService.getKeyValueByCode(fromModel.KEYREF.InflRt);
    this.incomeOwners = this.dataService.getPlanOwners();

    this.form.valueChanges.subscribe(fm=>{
      if(fm.amount){
        this.form.patchValue({amount: this.currencyPipe.transform(Utils.getCurrency(fm.amount), 'USD', 'symbol', '1.0-0')}, {emitEvent: false});
      }
    });

    if(this.inputData.incomeId){
      this.mode = "edit"; 
      this.income = this.dataService.getIncomeByIncomeId(this.inputData.incomeId);       
    } else {
      this.mode = "add";       
      this.income = this.preparePlanIncome();      
    } 
    this.setFormValues();
  }




  setFormValues(){
    let desc;
    let type;
    let owner;
    let gType;    
    let gRate;   
    let taxable; 
    let adjToFutureDollar;
    let startType;
    let startYr;
    let startAge;
    let endType;
    let endYr;
    let duration;
    let endAge;
    let eAmount;
    let isMonthly;

    if(this.mode === "add"){
      //desc = `${this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Incomes, fromModel.INCOMETYPE.OT).value} Income`;
      //desc = '';
      //type = fromModel.INCOMETYPE.OT;
      //owner = this.dataService.getClientByRole(fromModel.CLIENTROLE.Primary).clientid;      

      desc = `${this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Incomes, this.inputData.incType).value} Income`;;      
      type = this.inputData.incType;
      owner = this.inputData.clientid; 
      taxable = 'true';  
      
      
      if(this.inputData.incType === fromModel.INCOMETYPE.AN){
        gType = fromModel.GROWTHTYPE.MNF;
        gRate = 0; 
        adjToFutureDollar = 'false';   
        isMonthly = 'true';  
      } else {
        gType = fromModel.GROWTHTYPE.INF;
        gRate = ''; 
        adjToFutureDollar = 'true';   
        isMonthly = 'false';  
      }
       
      
      if(this.inputData.incType === fromModel.INCOMETYPE.SS){
        startType = fromModel.AMOUNTPERIODTYPE.Age;
        startYr = '';
        startAge = fromModel.DEFAULTS.ssStart;  
        endType = fromModel.AMOUNTPERIODTYPE.AtEnd;      
        endYr = '';  
        endAge = ''; 
        duration = '';
      } else if(this.inputData.incType === fromModel.INCOMETYPE.AN){ 
        startType = fromModel.AMOUNTPERIODTYPE.Age;
        startYr = '';
        startAge = fromModel.DEFAULTS.anStart;  
        endType = fromModel.AMOUNTPERIODTYPE.AtEnd;      
        endYr = '';  
        endAge = ''; 
        duration = '';
      } else if(this.inputData.incType === fromModel.INCOMETYPE.EI || this.inputData.incType === fromModel.INCOMETYPE.SE){ 
        startType = fromModel.AMOUNTPERIODTYPE.Year;
        startYr = new Date().getFullYear();
        startAge = '';  
        endType = fromModel.AMOUNTPERIODTYPE.AtRet;      
        endYr = '';  
        endAge = ''; 
        duration = '';
      } else {
        startType = fromModel.AMOUNTPERIODTYPE.Age;
        startYr = '';
        startAge = '';
        endType = fromModel.AMOUNTPERIODTYPE.AtEnd;      
        endYr = '';  
        endAge = ''; 
        duration = '';
      }

      eAmount = '';       

      this.validateGrowthType(gType); 
      this.validateYearType(startType,"start");
      this.validateYearType(endType,"end");
      
    } else {
      desc = this.income.incDesc;
      type = this.income.incType;
      if(this.income.owner){
        owner = this.income.owner;
      } else {
        owner = '0';
      }
      
      gType = this.income.growthType;
      if(gType === fromModel.GROWTHTYPE.MNF){ 
        gRate = this.income.growthRate;      
      } else {
        gRate = '';
      }

      taxable = this.income.isTaxable.toString();  
      adjToFutureDollar = this.income.isAdjToFutureDollar.toString();
      
      startType = this.income.amtPeriod[0].startType;
      if(startType === fromModel.AMOUNTPERIODTYPE.Year){
        startYr = this.income.amtPeriod[0].startYr;
      } else {
        startYr = '';
      }      
      if(startType === fromModel.AMOUNTPERIODTYPE.Age){
        startAge = this.income.amtPeriod[0].startAge;
      } else {
        startAge = '';
      }

      endType = this.income.amtPeriod[0].endType;
      if(endType === fromModel.AMOUNTPERIODTYPE.Year){
        endYr = this.income.amtPeriod[0].endYr;
      } else {
        endYr = '';
      }      
      if(endType === fromModel.AMOUNTPERIODTYPE.Age){
        endAge = this.income.amtPeriod[0].endAge;
      } else {
        endAge = '';
      }

      if(endType === fromModel.AMOUNTPERIODTYPE.Duration){
        duration = this.income.amtPeriod[0].duration;
      } else {
        duration = '';
      }
      
      eAmount = this.income.amtPeriod[0].amount;
      isMonthly = this.income.isMonthly.toString();
      
      this.setIncomeType(type);
      this.validateGrowthType(gType);
      this.validateYearType(startType,"start");
      this.validateYearType(endType,"end");
      
    }

    this.form.setValue({
      incDesc: desc,
      incType: type,
      owner: owner,
      growthType: gType,
      growthRate: gRate,
      isTaxable: taxable,
      isAdjToFutureDollar: adjToFutureDollar,
      startType: startType,
      startYr: startYr,
      startAge: startAge,
      endType: endType,
      endYr: endYr,
      endAge: endAge,
      duration: duration,
      amount: this.currencyPipe.transform(eAmount, 'USD', 'symbol', '1.0-0'),
      isMonthly: isMonthly
    });
  }

  preparePlanIncome(){
    let startYear = new Date().getFullYear();
    //let endYear = startYear + (this.refDataService.getLifeExpectancyForClient(client.age, client.gender, fromModel.HEALTHCONDITION.Average, fromModel.SMOKER.N).endAge - client.age);
    let income: fromModel.Income = {
      "incId": Utils.newGuidByType(fromModel.GUIDTYPE.RCMINC),
      "incType": fromModel.INCOMETYPE.OT,
      "incDesc": '',      
      "owner": '',
      "growthType": fromModel.GROWTHTYPE.MNF,
      "growthRate": 0,
      "amtPeriod": [
        {
          "startType": fromModel.AMOUNTPERIODTYPE.Year, //Year, AtRet, Age
          "startYr": startYear,
          "startAge": 0,          
          "amount": 0,
          "endType": fromModel.AMOUNTPERIODTYPE.AtEnd, //Year, AtRet, Age, AtEnd
          "endYr": 0,
          "endAge": 0
        }
      ], 
      "isIncluded": true
    }; 

    return income;
  }

  selectTaxable(){

  }

  selectIncomeType(event: any, incType: fromModel.INCOMETYPE){
    if(event.isUserInput){
      this.setIncomeType(incType);
    }
  }

  selectIncomeFreqType(freType){

  }

  setIncomeType(incType: fromModel.INCOMETYPE){
    if(incType === fromModel.INCOMETYPE.SS){
      this.form.patchValue({startType: fromModel.AMOUNTPERIODTYPE.Age});
      //this.form.patchValue({startAge: this.refDataService.getKeyValueByCode(fromModel.KEYREF.SSStart)});        
      this.form.patchValue({startAge: fromModel.DEFAULTS.ssStart});     
      this.form.patchValue({endType: fromModel.AMOUNTPERIODTYPE.AtEnd});                
      this.validateYearType(fromModel.AMOUNTPERIODTYPE.Age,"start");
      this.validateYearType(fromModel.AMOUNTPERIODTYPE.AtEnd,"end");
      this.setValidators("startAge",[Validators.required, Validators.min(62), Validators.max(70)]);      
    } else {
      this.form.patchValue({startType: fromModel.AMOUNTPERIODTYPE.Age});        
      this.form.patchValue({startAge: ''});     
      this.form.patchValue({endType: fromModel.AMOUNTPERIODTYPE.AtEnd});        
      this.validateYearType(fromModel.AMOUNTPERIODTYPE.Age,"start");
      this.validateYearType(fromModel.AMOUNTPERIODTYPE.AtEnd,"end");
      this.setValidators("startAge",[Validators.required]);      
    }
  }
    
  selectGrowthType(growthType){
    this.validateGrowthType(growthType);
  }

  selectYearType(event: any, amountPeriodType: fromModel.AMOUNTPERIODTYPE, yearType){     
    if(event.isUserInput){
      this.validateYearType(amountPeriodType,yearType);
    }
  }
 
  clearValidators(field){
    this.form.controls[field].setErrors(null);    
    this.form.controls[field].clearValidators();
    this.form.controls[field].updateValueAndValidity();
  }

  setValidators(field, validators: ValidatorFn[]){
    this.form.controls[field].setValidators(validators);
    this.form.controls[field].updateValueAndValidity();
  }


  validateYearType(amountPeriodType: fromModel.AMOUNTPERIODTYPE, yearType){
    let yrField;
    let ageField;
    let durationField;

    if(yearType === 'start'){
      yrField = "startYr";
      ageField = "startAge";
    } else {
      yrField = "endYr";
      ageField = "endAge";
      durationField = "duration";
    }

    if(amountPeriodType === fromModel.AMOUNTPERIODTYPE.AtRet 
      || amountPeriodType === fromModel.AMOUNTPERIODTYPE.AtEnd){
      this.clearValidators(yrField);
      this.clearValidators(ageField);
      if(durationField){
        this.clearValidators(durationField);        
      }
    } else if(amountPeriodType === fromModel.AMOUNTPERIODTYPE.Duration){
      this.setValidators(durationField, [Validators.required]);
      this.clearValidators(yrField);      
      this.clearValidators(ageField);

    } else if(amountPeriodType === fromModel.AMOUNTPERIODTYPE.Age){
      this.setValidators(ageField, [Validators.required]);
      this.clearValidators(yrField);      
      if(durationField){
        this.clearValidators(durationField);        
      }
    } else if(amountPeriodType === fromModel.AMOUNTPERIODTYPE.Year){
      this.setValidators(yrField, [Validators.required]);
      this.clearValidators(ageField);      
      if(durationField){
        this.clearValidators(durationField);        
      }
    }
  }

  validateDuration(){
    let isValid=true;

    if(this.form.get('startType').value === fromModel.AMOUNTPERIODTYPE.Year
    && this.form.get('endType').value === fromModel.AMOUNTPERIODTYPE.Year)
    {      
      if(Number(this.form.get('startYr').value)>=Number(this.form.get('endYr').value)){
        isValid=false;
        this.validationMsg = Constant.ErrorMsgs.durationErrorMsg;
      }      
    } else if(this.form.get('startType').value === fromModel.AMOUNTPERIODTYPE.Age
    && this.form.get('endType').value === fromModel.AMOUNTPERIODTYPE.Age)
    {      
      if(Number(this.form.get('startAge').value)>=Number(this.form.get('endAge').value)){
        isValid=false;
        this.validationMsg = Constant.ErrorMsgs.durationErrorMsg;
      }      
    }
    return isValid;
  }

  validateGrowthType(growthType){
    if(growthType === fromModel.GROWTHTYPE.INF){
      //this.form.patchValue({growthRate: ''});
      this.clearValidators("growthRate");
    } else {
      this.setValidators("growthRate",[Validators.required]);      
    }
  }

  saveIncome(): void {
    if(this.form.valid && this.validateDuration()){
      //console.log(this.form.getRawValue());     
      this.income.incDesc = this.form.get('incDesc').value;  
      this.income.incType = this.form.get('incType').value;

      if(this.form.get('owner').value === "0"){
        this.income.owner =   '';
      } else {
        this.income.owner =   this.form.get('owner').value;
      }
      

      this.income.growthType = this.form.get('growthType').value;

      if(this.income.growthType === fromModel.GROWTHTYPE.MNF){
        this.income.growthRate = this.form.get('growthRate').value;
      }

      this.income.isTaxable = (this.form.get('isTaxable').value === "true");
      this.income.isAdjToFutureDollar = (this.form.get('isAdjToFutureDollar').value === "true"); 
      
      this.income.amtPeriod[0].startType = this.form.get('startType').value;      
      if(this.income.amtPeriod[0].startType === fromModel.AMOUNTPERIODTYPE.Year){
        this.income.amtPeriod[0].startYr = this.form.get('startYr').value;        
      } else if(this.income.amtPeriod[0].startType === fromModel.AMOUNTPERIODTYPE.Age){
        this.income.amtPeriod[0].startAge = this.form.get('startAge').value;
      }
      
      this.income.amtPeriod[0].endType = this.form.get('endType').value;
      if(this.income.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Year){
        this.income.amtPeriod[0].endYr = this.form.get('endYr').value;
      } else if(this.income.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Age){
        this.income.amtPeriod[0].endAge = this.form.get('endAge').value; 
      } else if(this.income.amtPeriod[0].endType === fromModel.AMOUNTPERIODTYPE.Duration){
        this.income.amtPeriod[0].duration = this.form.get('duration').value; 
      }
      
      this.income.amtPeriod[0].amount = Utils.getNumber(this.form.get('amount').value);
      this.income.isMonthly = (this.form.get('isMonthly').value === "true");


      if(this.mode === "edit"){
        this.dataService.dispatchAction(fromModel.DATA_ACTION.UPDATEINCOME, "EditIncomeComponent-saveIncome-UpdateExistingIncome", {income: this.income});
      } else if(this.mode === "add"){ 
        this.dataService.dispatchAction(fromModel.DATA_ACTION.ADDINCOME, "EditIncomeComponent-saveIncome-CreateNewIncome", {income: this.income});
      }
      this.dataService.savePlan();
      this.closeDialog(true);
    } else {
        console.log('There is a problem with the form.');
    }
  }

  deleteIncome(): void {
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.DELETEINCOME);    
  }

  openModelDialog(action: fromModel.OPENDIALOGACTIONS){
    switch(action){
      case fromModel.OPENDIALOGACTIONS.DELETEINCOME: {
        const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
          width: '500px',
          height: '240px',
          data: { deleteType: fromModel.DELETETYPE.Income, name: this.income.incDesc}                  
        }).afterClosed()
        .subscribe(isDeleted => {
          if(isDeleted){
            this.dataService.dispatchAction(fromModel.DATA_ACTION.DELETEINCOME, "EditIncomeComponent-openModelDialog-DeleteIcome", {income: this.income});
            this.dataService.savePlan();
            this.closeDialog(true);
          }
        });
        break;
      }     
    }
  }

  closeDialog(saved: boolean | false): void {
    this.dialogRef.close({isSaved: saved, income: this.income});
  }
  
 
  ngOnDestroy(): void{    
  }


  
  // formatCurrency(field){
  //   this.form.valueChanges.subscribe(fm=>{
  //     if(fm[field]){
  //       this.form.patchValue({
  //         field: this.currencyPipe.transform(fm[field].amount.replace(/\D/g,'').replace(/^0+/,''), 'USD', 'symbol', '1.0-0')
  //       }, {emitEvent: false});
  //     }
  //   });
  // }

  
  // formatCurrency(field){
  //   this.form.controls[field].valueChanges.subscribe(
  //     entertedText=>{
  //       this.form.controls[field].patchValue({field: this.currencyPipe.transform(Utils.getCurrency(entertedText), 'USD', 'symbol', '1.0-0')}, {emitEvent: false});
  //   });
  // }

}
